import _objectWithoutProperties from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _set from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/set";
import _getPrototypeOf from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import { DIRECTION, objectIncludes } from '../core/utils.js';
import ChangeDetails from '../core/change-details.js';
import createMask, { normalizeOpts } from './factory.js';
import Masked from './base.js';
import IMask from '../core/holder.js';
import '../core/continuous-tail-details.js';
/** Dynamic mask for choosing appropriate mask in run-time */

var MaskedDynamic =
/*#__PURE__*/
function (_Masked) {
  _inherits(MaskedDynamic, _Masked);

  /** Currently chosen mask */

  /** Compliled {@link Masked} options */

  /** Chooses {@link Masked} depending on input value */
  function MaskedDynamic(opts) {
    var _this;

    _classCallCheck(this, MaskedDynamic);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MaskedDynamic).call(this, _objectSpread({}, MaskedDynamic.DEFAULTS, opts)));
    _this.currentMask = undefined;
    return _this;
  }

  _createClass(MaskedDynamic, [{
    key: "updateOptions",
    value: function updateOptions(opts) {
      _get(_getPrototypeOf(MaskedDynamic.prototype), "updateOptions", this).call(this, opts);
    }
  }, {
    key: "_update",
    value: function _update(opts) {
      var _this2 = this;

      _get(_getPrototypeOf(MaskedDynamic.prototype), "_update", this).call(this, opts);

      if ('mask' in opts) {
        // mask could be totally dynamic with only `dispatch` option
        this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map(function (m) {
          return createMask(_objectSpread({
            overwrite: _this2._overwrite,
            eager: _this2._eager,
            skipInvalid: _this2._skipInvalid
          }, normalizeOpts(m)));
        }) : []; // this.currentMask = this.doDispatch(''); // probably not needed but lets see
      }
    }
  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }

      var details = this._applyDispatch(ch, flags);

      if (this.currentMask) {
        details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
      }

      return details;
    }
  }, {
    key: "_applyDispatch",
    value: function _applyDispatch(appended, flags, tail) {
      if (appended === void 0) {
        appended = '';
      }

      if (flags === void 0) {
        flags = {};
      }

      if (tail === void 0) {
        tail = '';
      }

      var prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
      var inputValue = this.rawInputValue;
      var insertValue = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._rawInputValue : inputValue;
      var tailValue = inputValue.slice(insertValue.length);
      var prevMask = this.currentMask;
      var details = new ChangeDetails();
      var prevMaskState = prevMask == null ? void 0 : prevMask.state; // clone flags to prevent overwriting `_beforeTailState`

      this.currentMask = this.doDispatch(appended, _objectSpread({}, flags), tail); // restore state after dispatch

      if (this.currentMask) {
        if (this.currentMask !== prevMask) {
          // if mask changed reapply input
          this.currentMask.reset();

          if (insertValue) {
            var d = this.currentMask.append(insertValue, {
              raw: true
            });
            details.tailShift = d.inserted.length - prevValueBeforeTail.length;
          }

          if (tailValue) {
            details.tailShift += this.currentMask.append(tailValue, {
              raw: true,
              tail: true
            }).tailShift;
          }
        } else if (prevMaskState) {
          // Dispatch can do something bad with state, so
          // restore prev mask state
          this.currentMask.state = prevMaskState;
        }
      }

      return details;
    }
  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder() {
      var details = this._applyDispatch();

      if (this.currentMask) {
        details.aggregate(this.currentMask._appendPlaceholder());
      }

      return details;
    }
  }, {
    key: "_appendEager",
    value: function _appendEager() {
      var details = this._applyDispatch();

      if (this.currentMask) {
        details.aggregate(this.currentMask._appendEager());
      }

      return details;
    }
  }, {
    key: "appendTail",
    value: function appendTail(tail) {
      var details = new ChangeDetails();
      if (tail) details.aggregate(this._applyDispatch('', {}, tail));
      return details.aggregate(this.currentMask ? this.currentMask.appendTail(tail) : _get(_getPrototypeOf(MaskedDynamic.prototype), "appendTail", this).call(this, tail));
    }
  }, {
    key: "currentMaskFlags",
    value: function currentMaskFlags(flags) {
      var _flags$_beforeTailSta, _flags$_beforeTailSta2;

      return _objectSpread({}, flags, {
        _beforeTailState: ((_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta2.currentMask) || flags._beforeTailState
      });
    }
  }, {
    key: "doDispatch",
    value: function doDispatch(appended, flags, tail) {
      if (flags === void 0) {
        flags = {};
      }

      if (tail === void 0) {
        tail = '';
      }

      return this.dispatch(appended, this, flags, tail);
    }
  }, {
    key: "doValidate",
    value: function doValidate(flags) {
      return _get(_getPrototypeOf(MaskedDynamic.prototype), "doValidate", this).call(this, flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
    }
  }, {
    key: "doPrepare",
    value: function doPrepare(str, flags) {
      if (flags === void 0) {
        flags = {};
      }

      var _get$call = _get(_getPrototypeOf(MaskedDynamic.prototype), "doPrepare", this).call(this, str, flags),
          _get$call2 = _slicedToArray(_get$call, 2),
          s = _get$call2[0],
          details = _get$call2[1];

      if (this.currentMask) {
        var currentDetails;

        var _get$call3 = _get(_getPrototypeOf(MaskedDynamic.prototype), "doPrepare", this).call(this, s, this.currentMaskFlags(flags));

        var _get$call4 = _slicedToArray(_get$call3, 2);

        s = _get$call4[0];
        currentDetails = _get$call4[1];
        details = details.aggregate(currentDetails);
      }

      return [s, details];
    }
  }, {
    key: "doPrepareChar",
    value: function doPrepareChar(str, flags) {
      if (flags === void 0) {
        flags = {};
      }

      var _get$call5 = _get(_getPrototypeOf(MaskedDynamic.prototype), "doPrepareChar", this).call(this, str, flags),
          _get$call6 = _slicedToArray(_get$call5, 2),
          s = _get$call6[0],
          details = _get$call6[1];

      if (this.currentMask) {
        var currentDetails;

        var _get$call7 = _get(_getPrototypeOf(MaskedDynamic.prototype), "doPrepareChar", this).call(this, s, this.currentMaskFlags(flags));

        var _get$call8 = _slicedToArray(_get$call7, 2);

        s = _get$call8[0];
        currentDetails = _get$call8[1];
        details = details.aggregate(currentDetails);
      }

      return [s, details];
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this$currentMask;

      (_this$currentMask = this.currentMask) == null ? void 0 : _this$currentMask.reset();
      this.compiledMasks.forEach(function (m) {
        return m.reset();
      });
    }
  }, {
    key: "remove",
    value: function remove(fromPos, toPos) {
      var details = new ChangeDetails();

      if (this.currentMask) {
        details.aggregate(this.currentMask.remove(fromPos, toPos)) // update with dispatch
        .aggregate(this._applyDispatch());
      }

      return details;
    }
  }, {
    key: "extractInput",
    value: function extractInput(fromPos, toPos, flags) {
      return this.currentMask ? this.currentMask.extractInput(fromPos, toPos, flags) : '';
    }
  }, {
    key: "extractTail",
    value: function extractTail(fromPos, toPos) {
      return this.currentMask ? this.currentMask.extractTail(fromPos, toPos) : _get(_getPrototypeOf(MaskedDynamic.prototype), "extractTail", this).call(this, fromPos, toPos);
    }
  }, {
    key: "doCommit",
    value: function doCommit() {
      if (this.currentMask) this.currentMask.doCommit();

      _get(_getPrototypeOf(MaskedDynamic.prototype), "doCommit", this).call(this);
    }
  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos, direction) {
      return this.currentMask ? this.currentMask.nearestInputPos(cursorPos, direction) : _get(_getPrototypeOf(MaskedDynamic.prototype), "nearestInputPos", this).call(this, cursorPos, direction);
    }
  }, {
    key: "maskEquals",
    value: function maskEquals(mask) {
      return Array.isArray(mask) ? this.compiledMasks.every(function (m, mi) {
        if (!mask[mi]) return;

        var _mask$mi = mask[mi],
            oldMask = _mask$mi.mask,
            restOpts = _objectWithoutProperties(_mask$mi, ["mask"]);

        return objectIncludes(m, restOpts) && m.maskEquals(oldMask);
      }) : _get(_getPrototypeOf(MaskedDynamic.prototype), "maskEquals", this).call(this, mask);
    }
  }, {
    key: "typedValueEquals",
    value: function typedValueEquals(value) {
      var _this$currentMask5;

      return Boolean((_this$currentMask5 = this.currentMask) == null ? void 0 : _this$currentMask5.typedValueEquals(value));
    }
  }, {
    key: "value",
    get: function get() {
      return this.currentMask ? this.currentMask.value : '';
    },
    set: function set(value) {
      _set(_getPrototypeOf(MaskedDynamic.prototype), "value", value, this, true);
    }
  }, {
    key: "unmaskedValue",
    get: function get() {
      return this.currentMask ? this.currentMask.unmaskedValue : '';
    },
    set: function set(unmaskedValue) {
      _set(_getPrototypeOf(MaskedDynamic.prototype), "unmaskedValue", unmaskedValue, this, true);
    }
  }, {
    key: "typedValue",
    get: function get() {
      return this.currentMask ? this.currentMask.typedValue : '';
    } // probably typedValue should not be used with dynamic
    ,
    set: function set(value) {
      var unmaskedValue = String(value); // double check it

      if (this.currentMask) {
        this.currentMask.typedValue = value;
        unmaskedValue = this.currentMask.unmaskedValue;
      }

      this.unmaskedValue = unmaskedValue;
    }
  }, {
    key: "displayValue",
    get: function get() {
      return this.currentMask ? this.currentMask.displayValue : '';
    }
  }, {
    key: "isComplete",
    get: function get() {
      var _this$currentMask2;

      return Boolean((_this$currentMask2 = this.currentMask) == null ? void 0 : _this$currentMask2.isComplete);
    }
  }, {
    key: "isFilled",
    get: function get() {
      var _this$currentMask3;

      return Boolean((_this$currentMask3 = this.currentMask) == null ? void 0 : _this$currentMask3.isFilled);
    }
  }, {
    key: "state",
    get: function get() {
      var _this$currentMask4;

      return _objectSpread({}, _get(_getPrototypeOf(MaskedDynamic.prototype), "state", this), {
        _rawInputValue: this.rawInputValue,
        compiledMasks: this.compiledMasks.map(function (m) {
          return m.state;
        }),
        currentMaskRef: this.currentMask,
        currentMask: (_this$currentMask4 = this.currentMask) == null ? void 0 : _this$currentMask4.state
      });
    },
    set: function set(state) {
      var compiledMasks = state.compiledMasks,
          currentMaskRef = state.currentMaskRef,
          currentMask = state.currentMask,
          maskedState = _objectWithoutProperties(state, ["compiledMasks", "currentMaskRef", "currentMask"]);

      if (compiledMasks) this.compiledMasks.forEach(function (m, mi) {
        return m.state = compiledMasks[mi];
      });

      if (currentMaskRef != null) {
        this.currentMask = currentMaskRef;
        this.currentMask.state = currentMask;
      }

      _set(_getPrototypeOf(MaskedDynamic.prototype), "state", maskedState, this, true);
    }
  }, {
    key: "overwrite",
    get: function get() {
      return this.currentMask ? this.currentMask.overwrite : this._overwrite;
    },
    set: function set(overwrite) {
      this._overwrite = overwrite;
    }
  }, {
    key: "eager",
    get: function get() {
      return this.currentMask ? this.currentMask.eager : this._eager;
    },
    set: function set(eager) {
      this._eager = eager;
    }
  }, {
    key: "skipInvalid",
    get: function get() {
      return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
    },
    set: function set(skipInvalid) {
      this._skipInvalid = skipInvalid;
    }
  }]);

  return MaskedDynamic;
}(Masked);

MaskedDynamic.DEFAULTS = void 0;
MaskedDynamic.DEFAULTS = {
  dispatch: function dispatch(appended, masked, flags, tail) {
    if (!masked.compiledMasks.length) return;
    var inputValue = masked.rawInputValue; // simulate input

    var inputs = masked.compiledMasks.map(function (m, index) {
      var isCurrent = masked.currentMask === m;
      var startInputPos = isCurrent ? m.value.length : m.nearestInputPos(m.value.length, DIRECTION.FORCE_LEFT);

      if (m.rawInputValue !== inputValue) {
        m.reset();
        m.append(inputValue, {
          raw: true
        });
      } else if (!isCurrent) {
        m.remove(startInputPos);
      }

      m.append(appended, masked.currentMaskFlags(flags));
      m.appendTail(tail);
      return {
        index: index,
        weight: m.rawInputValue.length,
        totalInputPositions: m.totalInputPositions(0, Math.max(startInputPos, m.nearestInputPos(m.value.length, DIRECTION.FORCE_LEFT)))
      };
    }); // pop masks with longer values first

    inputs.sort(function (i1, i2) {
      return i2.weight - i1.weight || i2.totalInputPositions - i1.totalInputPositions;
    });
    return masked.compiledMasks[inputs[0].index];
  }
};
IMask.MaskedDynamic = MaskedDynamic;
export { MaskedDynamic as default };